import * as React from 'react';
import { Story, } from '../../model';
import { storyImage } from '../../utils/default';
import styles from './searchfileitem.module.scss';
import { Flex, Header, Text, Image, AcceptIcon } from '@fluentui/react-northstar';
import cx from 'classnames';
import { Stack } from '@fluentui/react';

const SearchStoryItem = ({
    disable = false,
    permId,
    title,
    name,
    thumbnail,
    highlightedExcerpt,
    excerpt,
    id,
    defaultColour,
    colour,
    files,
    checked,
    onItemClick,
    ...rest
}: {onItemClick: (storyId: number) => void, checked: boolean, disable?: boolean } & Story) => {


    let url = storyImage;
    if (rest.coverArt) {
        url = rest.coverArt.url;
    }
    if(thumbnail) {
        url = thumbnail;
    }
    let markup = { __html: `...${highlightedExcerpt || excerpt || ' '}` };
    if(!(highlightedExcerpt || excerpt)) {
        markup = { __html: ' ' };
    }
    const inLineStyle: any = {};
    if(url && url.indexOf("data:image/svg") >= 0) {
        inLineStyle.backgroundColor = defaultColour || colour;
    }
    const rootClass = cx(styles.root, checked && styles.checked);
    return (
        <Stack className={rootClass}>
        <Flex onClick={() => onItemClick && !disable && onItemClick(permId)} className={styles.innerContainer} gap="gap.medium" padding="padding.medium">
            {checked && <div className={styles.check}><AcceptIcon style={{ backgroundColor: disable ? 'grey' : "#6264A7", color: "white" }} circular={true} size={"small"} /></div>}
            <div className={styles.thumbContainer}>
            </div>
            <Flex.Item className={styles.thumbContainer}>
                <Flex className={styles.thumbInnerContainer}>
                    <Image style={inLineStyle} className={styles.thumb} fluid src={url} />
                </Flex>
            </Flex.Item>

            <Flex className={styles.sidepanelDivContainer}>
                <Flex className={styles.sidepanelSpanContainer} column>
                    <Text className={styles.sidepanelSpanTitle}>{title || name}</Text>
                    <Text className={styles.sidepanelSpanDesc} dangerouslySetInnerHTML={markup} />
                </Flex>
            </Flex>
            <Flex className={styles.sidepanelMetaContainer}>
                <Flex className={styles.sidepanelMetaDivContainer} column>
                    <Text className={styles.sidepanelMetaSpan}>Story</Text>
                </Flex>
                <Text className={styles.sidepanelMetaDescSpan}>{`${files.length} Files`}</Text>
            </Flex>
        </Flex>
        <Flex className={styles.seperator}></Flex>
    </Stack>
    )
};
export default SearchStoryItem;
